/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateBotByRowIdInput = {|
  clientMutationId?: ?string,
  patch: BotPatch,
  rowId: any,
|};
export type BotPatch = {|
  name?: ?string,
  description?: ?string,
  avatar?: ?string,
|};
export type updateBotMutationVariables = {|
  input: UpdateBotByRowIdInput
|};
export type updateBotMutationResponse = {|
  +updateBotByRowId: ?{|
    +bot: ?{|
      +id: string,
      +rowId: any,
      +name: string,
      +description: ?string,
      +avatar: ?string,
    |}
  |}
|};
export type updateBotMutation = {|
  variables: updateBotMutationVariables,
  response: updateBotMutationResponse,
|};
*/


/*
mutation updateBotMutation(
  $input: UpdateBotByRowIdInput!
) {
  updateBotByRowId(input: $input) {
    bot {
      id
      rowId
      name
      description
      avatar
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateBotByRowIdInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateBotPayload",
    "kind": "LinkedField",
    "name": "updateBotByRowId",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Bot",
        "kind": "LinkedField",
        "name": "bot",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rowId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "avatar",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateBotMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateBotMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateBotMutation",
    "operationKind": "mutation",
    "text": "mutation updateBotMutation(\n  $input: UpdateBotByRowIdInput!\n) {\n  updateBotByRowId(input: $input) {\n    bot {\n      id\n      rowId\n      name\n      description\n      avatar\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '05defcf69b55761350b9fb6bd4fa614a';

module.exports = node;
